import React from 'react'
import Heading from '../components/Heading'
import globals from '../globals'
import CustomLink from '../components/CustomLink'

const TelstraMigrateBanner = (props) => {
    return (
        <div className='module'>
            <Heading title='Migrate my mobile now' />
            <div className='module-inner p-4 text-center'>
                <div className='row'>
                    <div className='col-12 col-lg-10 offset-lg-1'>
                        <h1 className='mt-2 mb-2' dangerouslySetInnerHTML={{ __html: globals.noWidows('You need to migrate your ExeSIM mobile service now!') }} />
                        <p className='m-0 mb-4 lh'>We’re guessing you’ve seen the emails and SMS’s we’ve pinged your way letting you know we are switching our mobile business to Telstra. Well, the time has come where you really need to migrate your ExeSIM service ASAP. So avoid the disappointment and migrate your ExeSIM service now.</p>

                        <h3 className='m-0 mb-1 bold lh'>Migrating your mobile service is easy</h3>
                        <p className='m-0 mb-2 font-small'>(you will keep your mobile number)</p>
                        <p className='m-0 mb-4 lh'>Just click the button below and choose your new ExeSIM mobile plan with huge monthly data allowances and rollover into your Data Bank up to 500GB. We’ll then send you a new SIM via Australia post which you can activate back here in My Exetel. It’s that easy.</p>

                        <CustomLink to='/migrate-mobile' className='btn btn-custom mb-2'>Migrate ExeSIM now</CustomLink>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TelstraMigrateBanner



// WEBPACK FOOTER //
// ./resources/js/modules/TelstraMigrateBanner.js